import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';

import Input from '../../modules/Input';
import Button from '../../modules/Button';
import InputGroup from '../../modules/InputGroup';
import FormButtonPanel from '../../modules/FormButtonPanel';
import AlertBox from '../../modules/AlertBox';
import AlertMessage from '../../modules/AlertMessage';

import styles from './styles.scss';

class Login extends React.Component {

    _getErrorMessage(error) {

        switch (error.message) {
            case 'invalid_credentials':
                return <p>Your email or password was invalid, please try again or reset your password using the <a href="/forgotten-password" aria-label="Forgotten Password Link">forgotten password</a> page</p>
            case 'account_not_confirmed':
                return <p>Your account hasn't been confirmed yet. Please find your confirmation email from us and click the link inside.</p>
            case 'generic_error':
                return <p>There was a problem trying to log you in. Please contact <a href="mailto:support@rheglobal.com">support@rheglobal.com</a></p>
            case 'no_username_specified':
                return <p>Your email is required.</p>
            case 'no_password_specified':
                return <p>Your password is required.</p>
            case 'account_locked':
                return <p>Too many failed login attempts, try again in {error.remaining_minutes} minutes.</p>

            default: return ``
        }
    }
    render() {

        const { handleSubmit, pristine, submitting, error } = this.props;

        return (
            <div>

                <AlertMessage>
                    {error && (
                        <AlertBox theme="danger">
                            {this._getErrorMessage(error)}
                        </AlertBox>
                    )}
                </AlertMessage>

                <form onSubmit={handleSubmit}>
                    <InputGroup>
                        <Field name="email" component={Input} type="email" required="true" label="Email" />
                    </InputGroup>

                    <InputGroup>
                        <Field name="password" component={Input} type="password" required="true" label="Password" />
                    </InputGroup>

                    <FormButtonPanel position="bottom">
                        <Button type="submit" disabled={pristine || submitting}>Login</Button>
                    </FormButtonPanel>

                    <Link className={styles['forgotten-password-link']} to="/forgotten-password">Forgotten your password?</Link>
                </form>
            </div>
        )
    }
}

export default reduxForm({ form: 'login' })(Login);